import axios from "axios";
import catAppConfig from '../app.config';
var catBasePath = catAppConfig.settings.baseUrl
export default {
  async getAllProjects() {
    try {
      return await axios.get(`${catBasePath}Project/GetAllProjects`);
    } catch (error) {
      return error.response;
    }
  },

  async getProjectById(projectId) {
    try {
      return await axios.get(`${catBasePath}Project/GetProject/${projectId}`);
    } catch (error) {
      return error.response;
    }
  },

    async getAllCatalystData(pageNo, pageSize){
    try {    
      return await axios.get(`${catBasePath}CatalystReactorData/Page/${pageNo}?size=${pageSize}`);
    } catch (error) {
      return error.response;
    }
  },
  async getAllFilterOptions(filterParam){
    try {
      return await axios.post(`${catBasePath}CatalystReactorData/getfilters`, filterParam);
    } catch (error) {
      return error.response;
    }s
},
  async createCatalystReactorData(catalyst){
    try {
      return await axios.post(`${catBasePath}CatalystReactorData/AddCatalystReactorData`, catalyst);
    } catch (error) {
      return error.response;
    }
},
  async filterTabledata(filterValue){
      try {
        return await axios.post(`${catBasePath}CatalystReactorData/filter`, filterValue);
      } catch (error) {
        return error.response;
      }
  },
    async saveEditingStatus(params) {
      try {
        return await axios.put(`${catBasePath}CatalystReactorData/Editing`, params);
      } catch (error) {
        return error.response;
      }
    },
    async showHistoryRecord(id,pageNo) {
      try {
        return await axios.get(`${catBasePath}CatalystReactorData/GetAllPagHistory?id=${id}&page=${pageNo}`);
      } catch (error) {
        return error.response;
      }
    },
    async getDataById(id) {
      try {
        return await axios.get(`${catBasePath}CatalystReactorData/GetCatalystReactorDatasById/${id}`);
      } catch (error) {
        return error.response;
      }
    },
  async updateTablerow(row){
    try {
      return await axios.put(`${catBasePath}CatalystReactorData/UpdateCatalystReactorData`, row);
    } catch (error) {
      return error.response;
    }
  },
  async getAllUniqueFilterRecord(){
    try {
      return await axios.get(`${catBasePath}CatalystReactorData/UniqueFilterRecord`);
    } catch (error) {
      return error.response;
    }
  },
  async getAllCatalystMasterDataddl(){
    try {
      return await axios.get(`${catBasePath}CatalystReactorMaster/UniqueFilterMasterRecord`);
    } catch (error) {
      return error.response;
    }
  },
  async getFilterdata (filterParamters){
    try {
      return await axios.post(`${catBasePath}CatalystReactorData/getfilters`, filterParamters);
    } catch (error) {
      return error.response;
    }
  },
  async getAllReportBySiteAndMfg(filterValue){
    try {
      return await axios.post(`${catBasePath}CatalystReactorData/GetReportBySiteAndMfg`,filterValue);
    } catch (error) {
      return error.response;
    }
  },
  async getAllGetReportByMfg(filterValue){
    try {
      return await axios.post(`${catBasePath}CatalystReactorData/GetReportByMfg`,filterValue);
    } catch (error) {
      return error.response;
    }
  },
  async getAllGetReportByCategory(filterValue){
    try {
      return await axios.post(`${catBasePath}CatalystReactorData/GetReportByCategory`,filterValue);
    } catch (error) {
      return error.response;
    }
  },
  async getAllCatalystReactorDatas(){
    try {
      return await axios.get(`${catBasePath}CatalystReactorData/GetAllCatalystReactorDatas`);
    } catch (error) {
      return error.response;
    }
  },
  async GetAllConversionDatas(){
    try {
      return await axios.get(`${catBasePath}CatalystReactorData/GetAllConversionDatas`);
    } catch (error) {
      return error.response;
    }
  },
  async getAllCatalystReactorMaster(pageNo, pageSize){
    try {    
      return await axios.get(`${catBasePath}CatalystReactorMaster/Page/${pageNo}?size=${pageSize}`);
    } catch (error) {
      return error.response;
    }
  },
  async CRDExport(pageNo, pageSize){
    try {    
      return await axios.post(`${catBasePath}CatalystReactorData/CRDExport?PageNo=${pageNo}&size=${pageSize}`,{},{ responseType: 'blob'});
    } catch (error) {
      return error.response;
    }
  },
  async getFilterCatalystReactorMaster(pageNum,size,searchInput){
    try {    
      return await axios.get(`${catBasePath}CatalystReactorMaster/GetAllCatalystReactorMasters?FieldName=${searchInput}&PageNo=${pageNum}&size=${size}`);
    } catch (error) {
      return error.response;
    }
  },
  async addCatalystReactorMaster(itemValue){
    try {    
      return await axios.post(`${catBasePath}CatalystReactorMaster/AddCatalystReactorMaster`,itemValue);
    } catch (error) {
      return error.response;
    }
  },
  async updateCatalystReactorMaster(masterItem){
    try {    
      return await axios.put(`${catBasePath}CatalystReactorMaster/UpdateCatalystReactorMaster`,masterItem);
    } catch (error) {
      return error.response;
    }
  },
  async deleteCatalystReactorMaster(itemId){
    try {
      return await axios.delete(`${catBasePath}CatalystReactorMaster/${itemId}`);      
    } catch (error) {
      return error.response;
    }
  },
  async getUserList(input){
    try {
      return await axios.get(`${catBasePath}AdUser/search/${input}`);
    } catch (error) {
      return error.response;
    }
  },
  async getAllUsers(){
    try {    
      return await axios.get(`${catBasePath}User/GetAllUsers`);
    } catch (error) {
      return error.response;
    }
  },
  async addUserData(userValue){
    try {    
      return await axios.post(`${catBasePath}User/AddUserData`,userValue);
    } catch (error) {
      return error.response;
    }
  },
  async updateUserData(user){
    try {    
      return await axios.put(`${catBasePath}User/UpdateUserData`,user);
    } catch (error) {
      return error.response;
    }
  },
  async deleteUser(userId){
    try {
      return await axios.delete(`${catBasePath}User/${userId}`);      
    } catch (error) {
      return error.response;
    }
  },
  async GetUserInfo(headerSettings) {
    try {
      return await axios.get(`${catBasePath}ADUser`, {
        headers: headerSettings,
      });
    } catch (error) {
      return error.response;
    }
  },
  async getUserProfilePic(headerSettings) {
    try {
      return await axios.get(`${catBasePath}AdUser/users/MyPhoto`, {
        headers: headerSettings,
      });
    } catch (error) {
      return error.response;
    }
  },
  async getNavigationDataRM (){
    try {
      return await axios.get(`${catBasePath}User/CatalystWikiNavigationDocument`, { responseType: 'blob'});
    } catch (error) {
      return error.response;
    }
  },
  async getFunctionalDataRM (){
    try {
      return await axios.get(`${catBasePath}User/CatalystWikiFunctionalDocument`, { responseType: 'blob'});
    } catch (error) {
      return error.response;
    }
  },
  async getTechnicalDataRM (){
    try {
      return await axios.get(`${catBasePath}User/CatalystWikiTechnicalDocument`, { responseType: 'blob'});
    } catch (error) {
      return error.response;
    }
  },
 };
